<template>
  <ValidationProvider ref="numberProvider" :name="$attrs['name'] || 'number'" rules="required" v-slot="{ errors }">
    <label for="inputEmail4" class="pb-2">{{ label }}</label>
    <v-text-field ref="inputRef" solo type="text" inputmode="number" v-bind="$attrs" @input="onInput($event)"
      @change="onChange($event)" @keydown="onKeydown($event)" :error-messages="errors"
      :placeholder="placeholder"></v-text-field>
  </ValidationProvider>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';

import { Regex } from '@/utils/regex';
import { Utils } from '@/utils/utils';

@Component
export default class NumberComponent extends Vue {
  @Prop({ default: '' }) inputValue!: string;
  @Prop({ default: 50 }) length!: number;
  @Prop({ default: -1 }) index!: number;
  @Prop({ default: 'الرجاء ملء الحقل' }) placeholder!: string;
  @Prop({ default: '' }) label!: string;

  onKeydown(event: KeyboardEvent) {
    Utils.AllowDigitsKeys(event);
  }

  onChange(value: string) {
    if (!Regex.Numbers.test(value)) {
      (this.$refs.inputRef as any).reset();
    }
  }

  async onInput(value: string): Promise<void> {
    const result = (this.$refs.numberProvider as any).validate(value);
    this.$emit('update:inputValue', value);

    if (this.index !== -1) {
      this.$emit('controlDataChanged', { value, index: this.index, isValid: result.valid });
    }
  }
}
</script>
